import axiosInstance from "./AxiosInstance";

// List forms
export function getAssignedLeadHistory(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = "",
  status = "",
) {
  return axiosInstance.post("/lead/leadAssignedHistory", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order,
    status,
  });
}
